/** The tenant, its plan, and the health endpoint. */
import { z } from 'zod';
import { storageModeSchema } from './enums.js';
import { uuidSchema } from './primitives.js';
export const organizationSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    slug: z.string(),
    plan: z.string(),
    status: z.string(),
    /** Which side of the mode switch this tenant is on. `local` means the module owns tables
     *  inside the host's own database; `remote` means it calls the canonical service. Worth
     *  surfacing somewhere in a support screen: "created in CRM but not visible in Accounts"
     *  is almost always one host still in local mode after a promotion. */
    storage_mode: storageModeSchema,
    host_application: z.string().nullable().default(null),
    costing_scope: z.string().default('ITEM_WAREHOUSE'),
    feature_flags: z.record(z.unknown()).default({}),
});
export const organizationEnvelopeSchema = z.object({
    organization: organizationSchema.nullable(),
});
/**
 * What the tenant's plan allows.
 *
 * `suspended` is a billing kill switch: a suspended or cancelled organization resolves to
 * an empty feature set and every gated route refuses. A skin should say so plainly rather
 * than rendering an inventory module with every button greyed out and no explanation.
 *
 * Invariant 7 again: this is for rendering. The server checks on every gated route.
 */
export const entitlementsSchema = z.object({
    plan: z.string().nullable(),
    features: z.array(z.string()),
    suspended: z.boolean(),
});
export const healthSchema = z.object({
    status: z.string(),
    mode: storageModeSchema,
    store: z
        .object({
        mode: storageModeSchema,
        reachable: z.boolean(),
        detail: z.string(),
        checked_at: z.string(),
    })
        .passthrough(),
});
//# sourceMappingURL=organization.js.map